<template>
  <MasterLayout>
    <template #navbar>
      <BrandLinks :links="[
        ['https://www.cms.gov/', 'CMS.gov'],
        ['https://www.cms.gov/About-CMS/About-CMS', 'About CMS'],
        ['https://www.cms.gov/newsroom', 'Newsroom'],
        ['https://www.archive-it.org/collections/2744', 'Archive'],
      ]"/>
    </template>

    <template #footer>
      <SiteFooter />
    </template>
  </MasterLayout>
</template>

<script>
import MasterLayout from '@/components/MasterLayout';
import BrandLinks from '@/components/BrandLinks';
import SiteFooter from '@/cms/components/SiteFooter';

export default {
  components: {
    BrandLinks,
    MasterLayout,
    SiteFooter
  }
};
</script>
